<template>
  <div>
    <b-card no-body>
      <div>
        <b-button v-if="permissao.c" @click="novoContrato" variant="info" class="mb-2">
          <i class="fas fa-plus mr-2"></i>
          Adicionar contrato
        </b-button>
      </div>
      <div class="row">
        <input-select-filter
          label="Empresa"
          :options="empresas"
          class="col-12 col-md-6"
          v-model="filtro.empresaId"
          required
        />
        <input-select
          label="Visualizar"
          class="col-12 col-md-6"
          :options="opcoes"
          v-model="filtro.visualizar"
        >
          <template #append>
            <div class="d-flex">
              <b-button @click="buscar" variant="info" class="ml-2">
                <i class="fas fa-search mr-2"></i>
                Buscar
              </b-button>
            </div>
          </template>
        </input-select>
      </div>
      <div class="table-responsive">

        <b-tabela  v-if="permissao.u || isAdmin" @doisClicksLinha="abrirEditar" :colunas="colunas" :dados="dados">
          <template v-slot:cell(acoes)="item">
            <div class="d-flex">
              <b-button variant="flat-primary" v-if="permissao.u || isAdmin" @click="abrirEditar(item.item.item)">
                <i class="fas fa-edit"></i>
              </b-button>
              <b-button variant="flat-danger" v-if="permissao.d || isAdmin" @click="excluir(item.item.item)">
                <i class="fas fa-trash"></i>
              </b-button>
              <b-button variant="flat-primary" class="mr-2" @click="download(item.item.item)" >
                <i class="fa-solid fa-cloud-arrow-down"></i>
              </b-button>
            </div>
          </template>
        </b-tabela>

        <b-tabela v-else  :colunas="colunas" :dados="dados">
          <template v-slot:cell(acoes)="item">
            <div class="d-flex">
              <b-button variant="flat-primary" @click="abrirEditar(item.item.item)">
                <i class="fas fa-edit"></i>
              </b-button>
              <b-button variant="flat-danger" v-if="permissao.d" @click="excluir(item.item.item)">
                <i class="fas fa-trash"></i>
              </b-button>
              <b-button variant="flat-primary" class="mr-2" @click="download(item.item.item)" >
                <i class="fa-solid fa-cloud-arrow-down"></i>
              </b-button>
            </div>
          </template>
        </b-tabela>
      </div>
    </b-card>
  </div>
</template>
<script>
import ContratoLicencaService from "@/common/services/contrato_licenca/contrato_licenca.service";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import { AlertasMixin } from "../../common/mixins/AlertasMixin";
import jwt_decode from "jwt-decode";
import helpers from "../../common/utils/helpers";
import InputSelectFilter from "../../components/inputs/InputSelectFilter.vue";
import InputSelect from "../../components/inputs/InputSelect.vue";
import EmpresasService from "@/common/services/empresas/empresas.service";

export default {
  components: {
    InputSelectFilter,
    InputSelect,
  },
  mixins: [AlertasMixin],
  data: () => ({
    dados: [],
    colunas: [
      { key: "empresa.nomeFantasia", label: "Empresa(Nome fantasia)" },
      {
        key: "dataAssinatura",
        label: "Data de assinatura",
        formatter: (value) => {
          if (value) return helpers.formatarDataBr(value);
        },
      },
      {
        key: "dataEncerramento",
        label: "Data de encerramento",
        formatter: (value) => {
          if (value) return helpers.formatarDataBr(value);
        },
      },
      { key: "acoes", label: "Ações" },
    ],
    filtro: {
      empresaId: null,
      visualizar: null,
    },
    empresas: [],
    opcoes: [
      { value: null, text: "Todos" },
      { value: "somenteVigencia", text: "Somente em vigência" },
      { value: "somenteEncerrados", text: "Somente encerrados" },
    ],
  }),
  methods: {
    buscar: function () {
      this.$store.dispatch(START_LOADING);
      ContratoLicencaService.listarContratos(this.filtro)
        .then((response) => {
          this.dados = response.data.data.itens;
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    buscarEmpresas: function () {
      EmpresasService.listar().then((result) => {
        result.data.data.itens.sort((a, b) =>
          (a.nomeFantasia || a.razaoSocial).localeCompare(b.nome)
        );
        this.empresas = [
          { value: null, text: "Todas" },
          ...result.data.data.itens.map((el) => {
            return {
              text: el.nomeFantasia || el.razaoSocial,
              value: el.id,
            };
          }),
        ];
      });
    },
    abrirEditar: function (item) {
        this.$router.push({ name: "contrato-licenca-formulario", params: { id: item.id } });
    },
    download: function (item) {
      this.$store.dispatch(START_LOADING);

      ContratoLicencaService.downloadContrato(item.id)
      .then(response => {
          helpers.baixarArquivo(response.data, response.headers);
          this.alertaSucesso("Download do Arquivo Concluido!");               
      })
      .catch(err => {
          console.log(err);
          this.alertaErro("Erro ao fazer Download do Arquivo");
      })
      .finally(() => {
          this.$store.dispatch(STOP_LOADING);
      });
    },
    excluir: function (item) {
      this.confirmar("Deseja realmente excluir o contrato?").then((confirmado) => {
        if (confirmado) {
          this.$store.dispatch(START_LOADING);
          ContratoLicencaService.removerLicenca(item.id)
            .then(() => {
              this.buscar();
              this.alertaSucesso("Contrato excluído com sucesso!");
            })
            .catch((err) => {
              if (err.response.status == 400) {
                this.alertaErro(err.response.data.errors);
              } else this.alertaErro("Erro ao excluir o contrato!");
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      });
    },
    novoContrato: function () {
      this.$router.push({ name: "contrato-licenca-formulario" });
    },
  },
  mounted() {
    if(!this.permissao.u && !this.isAdmin) 
    {
      this.$router.push({ name: "dashboard" });
    }
    this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: "Contratos de licença" }]);
    this.buscar();
    this.buscarEmpresas();
  },
  computed: {
    permissao() {
        return this.$store.state.app.permissao.find(item=>item.campo==='ContratoLicenca');
    },
    isAdmin() 
   {
    let token = localStorage.getItem("usuario_token");
    let userData = jwt_decode(token);
    return userData.role.includes("admin")
    },
  }
};
</script>
<style lang=""></style>
